'use client';
export { VirtualizedList } from 'react-native';
